import React from "react";

import { Field } from "formik";

import StringHelper from "~/helpers/StringHelper";
import InputErrorMessage from "~/admin/components/InputErrorMessage";

export const getInputClassName = (formikMeta, className) => {
  let borderClass =
    "border-gray-300 active:border-gray-300 focus:border-gray-300";

  if (formikMeta) {
    const { touched, error } = formikMeta;

    if (touched) {
      borderClass = StringHelper.isNullOrEmpty(error)
        ? "border-2 border-success active:border-success focus:border-success"
        : "border-2 border-danger active:border-danger focus:border-danger";
    }
  }

  return `block w-full font-[Roboto] text-sm text-black md:text-base py-2 px-3 transition-border-color ease-in-out duration-150 
  bg-white
  focus:ring-0 active:ring-0 hover:ring-0
  border rounded-xl ${borderClass}
  ${className}`;
};

export default function Input({
  className = "",
  name,
  type = "text",
  onChange,
  onBlur,
  ...inputProps
}) {
  return (
    <>
      <Field name={name}>
        {({ field, form, meta }) => {
          return (
            <input
              type={type}
              {...inputProps}
              className={` ${getInputClassName(meta, className)}`}
              {...field}
              value={meta.value ?? ""}
              onChange={(e) => {
                field.onChange(e);
                onChange && onChange(e, form);
              }}
              onBlur={(e) => {
                onBlur && onBlur(e, form);
                field.onBlur(e);
              }}
              autoComplete="off"
            />
          );
        }}
      </Field>
      <InputErrorMessage name={name} />
    </>
  );
}
